import MissionTimeTracker from "../components/MissionTimeTracker";

export function withMissionTracking(Component: React.FC, missionNumber: number)
{
	return () => (
		<MissionTimeTracker missionNumber={missionNumber}>
			<Component />
		</MissionTimeTracker>
	);

}
